// useReportSelector.ts
import { useEffect, useState } from 'react';
import axios from 'axios';
import { SelectChangeEvent } from '@mui/material'; // Import SelectChangeEvent
import { Filter } from '../../../../features/filters/FilterTypes';

export interface Report {
    name: string;
}

const useReportSelector = () => {
    const [reports, setReports] = useState<Report[]>([]);
    const [selectedReport, setSelectedReport] = useState<string>('');
    const [filters, setFilters] = useState<Record<string, string>>({});
    const [filterValues, setFilterValues] = useState<Record<string, string>>({});
    const [reportResult, setReportResult] = useState<ReportResult | null>(null);

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await axios.get<Report[]>('/api/report');
                setReports(response.data);
            } catch (error) {
                console.error('Error fetching reports:', error);
            }
        };

        fetchReports();
    }, []);

    const handleReportChange = (event: SelectChangeEvent<string>) => {
        // Use SelectChangeEvent
        const reportName = event.target.value as string;
        setSelectedReport(reportName);
        setFilterValues({});
    };

    const handleFilterChange = (filterName: string, value: string) => {
        setFilterValues((prev) => ({ ...prev, [filterName]: value }));
    };

    const handleGenerateReport = async (filters: Filter) => {
        try {
            const response = await axios.post(`/api/report/${selectedReport}`, filters);
            console.log('Report generated:', response.data);
            // Handle the report result as needed (e.g., show a download link or display it)

            setReportResult(response.data);
        } catch (error) {
            console.error('Error generating report:', error);
        }
    };

    return {
        reports,
        selectedReport,
        filters,
        filterValues,
        handleReportChange,
        handleFilterChange,
        handleGenerateReport,
        reportResult,
    };
};

export default useReportSelector;
